import "@/App.css";
import SmoothScroll from "@/components/SmoothScroll";
import Navbar from "@/components/Navbar";
import TokenTicker from "@/components/TokenTicker";
import HeroSection from "@/components/HeroSection";
import OverviewSection from "@/components/OverviewSection";
import MarketSection from "@/components/MarketSection";
import RoadmapSection from "@/components/RoadmapSection";
import ContactSection from "@/components/ContactSection";
import Footer from "@/components/Footer";

function App() {
  return (
    <SmoothScroll>
      <div className="grain-overlay min-h-screen" style={{ background: '#060B1E' }}>
        <Navbar />
        <div className="pt-16">
          <TokenTicker />
        </div>
        <HeroSection />
        <OverviewSection />
        <MarketSection />
        <RoadmapSection />
        <ContactSection />
        <Footer />
      </div>
    </SmoothScroll>
  );
}

export default App;
